type ReploCustomEvent = "ActionStarted" | "ActionEnded";

export const ReploCustomEvents: Record<ReploCustomEvent, string> = {
  ActionStarted: "actionStarted",
  ActionEnded: "actionEnded",
};
